import React, { useContext } from 'react';
import logo from '../assets/images/nerdetcetera.png';
import footer from '../assets/images/footer.png';
import bg from '../assets/images/bg.jpg';
import { FaInstagram, FaFacebook, FaLinkedinIn, FaYoutube } from "react-icons/fa";

import LanguageContext from '../contexts/language';

export default function Footer({noLogo}) {

    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    return (
        <div className="footer bg-cover" style={{backgroundImage: `url(${bg})`}}>
            <div className="container mt-0 mb-0">
                <div className="footer-container">
                    <div className="footer-left">
                        <div>©2025 {language.site_name}</div>
                        <div className="social-icons">
                            <a href="#" className="social-icon"><FaInstagram /></a>
                            <a href="#" className="social-icon"><FaFacebook /></a>
                            <a href="#" className="social-icon"><FaLinkedinIn /></a>
                            <a href="#" className="social-icon"><FaYoutube /></a>
                        </div>
                    </div>
                    <div className="footer-right">{language.desenvolvido} <a className="dev_link" target="_blank" href="https://nerdetcetera.com"><img src={logo} /></a></div>
                </div>
            </div>
        </div>
    );
}